import { createStore } from 'redux';
import { videoReducer } from './video/reducer';

export const store = createStore(videoReducer);